import { render, staticRenderFns } from "./granaryDialog.vue?vue&type=template&id=084c5d79&scoped=true"
import script from "./granaryDialog.vue?vue&type=script&lang=js"
export * from "./granaryDialog.vue?vue&type=script&lang=js"
import style0 from "./granaryDialog.vue?vue&type=style&index=0&id=084c5d79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c5d79",
  null
  
)

export default component.exports